/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pb_Meta_DescInputs */

const en_pb_meta_desc = /** @type {(inputs: Pb_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready-made app recipes for Indonesian businesses, plus community playbooks from GitHub. Pick one and Bystep builds it step by step.`)
};

const id_pb_meta_desc = /** @type {(inputs: Pb_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resep aplikasi siap pakai untuk usaha di Indonesia, plus playbook komunitas dari GitHub. Pilih satu, Bystep membangunkannya langkah demi langkah.`)
};

/**
* | output |
* | --- |
* | "Ready-made app recipes for Indonesian businesses, plus community playbooks from GitHub. Pick one and Bystep builds it step by step." |
*
* @param {Pb_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const pb_meta_desc = /** @type {((inputs?: Pb_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pb_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_pb_meta_desc(inputs)
	return en_pb_meta_desc(inputs)
});